import React, { Component } from "react";
import { connect } from "react-redux";
import { Nav, NavItem, NavLink, TabContent, TabPane, Tooltip as RSTooltip } from "reactstrap";
import { IconButton, Tooltip as MLToolTip } from "@material-ui/core";
import { EditorTabGroup } from "../tools/EditorTabGroup";
import { sourceTypes } from "../../../../constants/cms/sourceType";
import TemplateSettings from "../../../areas/template/containers/TemplateSettings/TemplateSettings";
import { renderElementSettings } from "../../../helpers/renderElementSettings";
import { FormPagination } from "../../../areas/form/components/Pagination/Pagination";
import { formActions } from "../../../../store/actions/cms/form/form.action";
import { cmsActions } from "../../../../store/actions/cms/cms.action";
import { templateActions } from "../../../../store/actions/cms/template/template.action";
import { deepClone } from "../../../../helpers/objectHelper";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import PreviewOption from "../Nav/NavItems/PreviewOption";
import ElementsTab from "../ElementsTab/ElementsTab";
import "../../../style/EditorLayout.css";
import FormSettings from "../../../areas/form/components/FormSettings/FormSettings";
import { pageActions } from "../../../../store/actions/cms/page/page.action";
import { elementConstants } from "../../../../constants/cms/form/element/element.constants";
import RunFormOption from "../Nav/NavItems/RunFormOption/RunFormOption";
import { emailActions } from "../../../../store/actions/cms/email/email.action";
import { EmailElements } from "../../../areas/email/elementGroups/EmailElements";
import EmailSettings from "../../../areas/email/containers/EmailEditor/EmailSettings";
import SaveIcon from "@material-ui/icons/Save";
import RestorePageIcon from "@material-ui/icons/RestorePage";
import SettingsIcon from "@material-ui/icons/Settings";
import { labelHelper } from "../../../../helpers/labelHelper";
import Zoom from "@material-ui/core/Zoom";
import { Tooltip } from "@material-ui/core";
import SendTestEmail from "../../../areas/email/components/SendTestEmail";
import LaunchIcon from "@material-ui/icons/Launch";
import ConfirmModal from "../../ConfirmModal/ConfirmModal";
import InheritageWrapper from "../tools/Inheritage/InheritageWrapper";
import PageSettings from "../../../areas/page/components/PageSettings";
import TemplateInternalSettings from "../../../areas/template/components/TemplateInternalSettings";
import { alertActions } from "../../../../store/actions/alert.action";
import AlertDialog from "../../../../global/AlertDialog";

class EditorSidebar extends Component {
  state = {
    activeTab: "Elements",
    displayPopOver: false,
    confirmModal: false,
    inheritedElements: [],
    tooltips: {
      saveOpen: false,
      postOpen: false,
      templateOpen: false,
      clearOpen: false,
      prevPageOpen: false,
      nextPageOpen: false,
      addPageOpen: false,
      pageSettingsOpen: false,
      removePageOpen: false,
      formSettingsOpen: false,
      openPageOpen: false,
    },
    copyArea: "",
    copyName: "",
    affected: [],
  };
  componentDidMount() {
    if (this.props.getRefs) {
      this.props.getRefs({ asideEditorRef: this.asideEditorRef });
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.tempIsSavable === true && this.props.tempIsSavable === false) {
      this.save(true);
    }
    const {form,tempIsSavable,page,email} = this.props;
    if(form.isSavable || page.isSavable || tempIsSavable || email.isSavable){
    window.addEventListener("beforeunload", this.handleWindowBeforeUnload);

    }
    else{
    window.removeEventListener("beforeunload", this.handleWindowBeforeUnload);

    }
  }
  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleWindowBeforeUnload);
  }
  handleWindowBeforeUnload(e){
    var confirmationMessage = 'It looks like you have been editing something. '
    + 'If you leave before saving, your changes will be lost.';

        (e || window.event).returnValue = confirmationMessage; //Gecko + IE
        return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
  }
  toggleTooltip = (path) => {
    this.setState({
      tooltips: {
        ...this.state.tooltips,
        [path]: !this.state.tooltips[path],
      },
    });
  };
  toggle = (tab) => {
    if (tab === "FormSettings") {
      this.props.dispatch(formActions.deselect());
    }
    if (tab === "PageSettings") {
      this.props.dispatch(pageActions.deselect());
    }
    if (tab === "TemplateInternalSettings") {
      this.props.dispatch(templateActions.deselect());
    }
    this.setState({
      activeTab: tab,
    });
  };
  addPage = () => {
    const { dispatch } = this.props;
    dispatch(formActions.addPage());
  };
  removePage = () => {
    const { dispatch } = this.props;
    dispatch(formActions.removePage());
  };
  scrollPage = (page) => {
    const { dispatch } = this.props;
    const { form } = this.props;
    if (page <= form.pages || page >= 1) {
      dispatch(formActions.scrollPage(page));
    }
  };

  openPage = () => {
    const { page } = this.props;
    if (window.location.href.includes("localhost")) {
      window.open(`/p/${page.pageId.toString(36)}`);
    } else {
      window.open(`/cms/p/${page.pageId.toString(36)}`);
    }
  };
  parseElementNames = (el, lang) => {
    if (el.type === elementConstants.EVENT) return el.props.name;
    if (el.type === elementConstants.FIELD) return el.props.labels.find((l) => l.languageCode === lang).text;
    if (el.type === elementConstants.QUESTION) return el.props.labels.find((l) => l.languageCode === lang).text;
    if (el.type === elementConstants.CONTENT) return el.data.type;
    else return el.type;
  };
  save = (confirmed = false) => {
    const { dispatch, form, page, template, tempIsSavable, enviroment, cms, email, isOwner } = this.props;
    //If inherited items are affected
    if (!confirmed && cms.inheritageAffected) {
      const affected = [];
      //if the current area [FORM, PAGE, EMAIL, TEMPLATE] run this
      
      //The ugliest mf piece of code ever written (brainfart)
      if (
        !isOwner ||
        (cms.enviroment == sourceTypes.FORM && !confirmed && cms.inheritageAffected && template.eventId != cms.eventId && form.templateId == template.templateId) ||
        (cms.enviroment == sourceTypes.PAGE && !confirmed && cms.inheritageAffected && template.eventId != cms.eventId && page.templateId == template.templateId)
      ) {
        if (!isOwner) {
          let copyArea = "IsInheritedACopyWillBeCreated";
          let area = "";
          if (cms.enviroment == sourceTypes.FORM) {
            copyArea += "Form";
            area = "Form";
          }
          if (cms.enviroment == sourceTypes.PAGE) {
            copyArea += "Page";
            area = "Page";
          }
          if (cms.enviroment == sourceTypes.EMAIL) {
            copyArea += "EMAIL";
            area = "Email";
          }
          if (cms.enviroment == sourceTypes.TEMPLATE) {
            copyArea += "TEMPLATE";
            area = "Template";
          }
          affected.push({ area, name: "" });
          this.setState({ confirmModal: true, copyArea });
        }
        //If the template in the area is affected run these two!
        if (cms.enviroment == sourceTypes.FORM) {
          if (!confirmed && cms.inheritageAffected && template.eventId != cms.eventId && form.templateId == template.templateId && tempIsSavable) {
            affected.push({ area: "Template", name: "" });
            this.setState({
              confirmModal: true,
              copyArea: this.state.copyArea ? (this.state.copyArea += "AndTemplate") : "IsInheritedACopyWillBeCreatedTemplate",
            });
          }
        }
        if (cms.enviroment == sourceTypes.PAGE) {
          if (!confirmed && cms.inheritageAffected && template.eventId != cms.eventId && page.templateId == template.templateId && tempIsSavable) {
            affected.push({ area: "Template", name: "" });
            this.setState({
              confirmModal: true,
              copyArea: this.state.copyArea ? (this.state.copyArea += "AndTemplate") : "IsInheritedACopyWillBeCreatedTemplate",
            });
          }
        }
        this.setState({ affected });
        if (affected && affected.length > 0) return;
      }
    }
    if (!confirmed && cms.enviroment === sourceTypes.FORM && !isOwner) {
      if (!form.inheritParentId && form.inherit !== null) {
        let elText = null;
        let inheritedElements = [];
        if (form.formElements.find((fe) => fe.props.inherit == null)) {
          form.formElements.map((f) => {
            if (f.props.inherit == null) {
              inheritedElements.push(f);
            }
          });
        }
        if (inheritedElements.length > 0) {
          elText = (
            <div>
              <div>
                <SystemLabel name="ElementsNeedAdjustment" />
              </div>
              <br />
              {inheritedElements.map((ie) => {
                return <div>{this.parseElementNames(ie, form.languageCode)}</div>;
              })}
            </div>
          );
        }
        this.setState({ confirmModal: true, inheritedElements: elText });
        return;
      }
    }
    this.setState({ confirmModal: false, copyArea: "" });
    const newTemplate = deepClone(template);
    if (tempIsSavable) {
      const newTemp = this.state.affected.find((a) => a.area == "Template");
      newTemplate.name = newTemp ? newTemp.name : newTemplate.name;
      newTemplate.eventId = cms.eventId;
      dispatch(templateActions.checkForUpdates(newTemplate));
    } else {
      if (enviroment === sourceTypes.FORM) {
        if (
          form.formElements.find(
            (el) =>
              !el.props &&
              el.type != elementConstants.INVOICE_FIELD &&
              el.type != elementConstants.CONTAINER &&
              el.type != elementConstants.PAYMENT_OPTIONS &&
              el.type != elementConstants.PROFILEIMAGE_UPLOAD &&
              el.type != elementConstants.DISCOUNT &&
              el.type != elementConstants.PRE_CONFIRMATION &&
              el.type != elementConstants.GROUP_REGISTRATION &&
              el.type != elementConstants.FILE_UPLOADER
          )
        ) {
          dispatch(alertActions.error("YouHaveDeletedElementsInForm", "RemoveAllMarkedElementsThenSave"));
          return;
        }
        const newForm = deepClone(form);
        newForm.templateId = newTemplate.templateId;
        const newF = this.state.affected.find((a) => a.area == "Form");
        newForm.name = newF ? newF.name : newForm.name;
        /*         newForm.name = this.state.copyName || newForm.name; */
        if (newForm.templateId != template.templateId) newForm.templateId = template.templateId;
        if (newForm.isSavable || form.templateId !== newTemplate.templateId) dispatch(formActions.checkForUpdates(newForm));
      }
      if (enviroment === sourceTypes.PAGE) {
        const newPage = deepClone(page);
        newPage.templateId = newTemplate.templateId;
        const newP = this.state.affected.find((a) => a.area == "Page");
        newPage.name = newP ? newP.name : newPage.name;
        /*    newPage.name = this.state.copyName || newPage.name; */

        if (newPage.templateId != template.templateId) newPage.templateId = template.templateId;
        if (newPage.isSavable || page.templateId !== newTemplate.templateId) dispatch(pageActions.checkForUpdates(newPage));
      }
      if (enviroment === sourceTypes.EMAIL) {
        if (!email.subject) {
          dispatch(alertActions.error("EmailRequriesSubject", "AddASubjectAndThenSave"));
          return;
        }
        const newMail = deepClone(email);
        newMail.templateId = newTemplate.templateId;
        const newM = this.state.affected.find((a) => a.area == "Email");
        newMail.name = newM ? newM.name : newMail.name;
        /*   newMail.name = this.state.copyName || newMail.name; */

        dispatch(emailActions.update(newMail));
      }
    }
    this.setState({ affected: [] });
  };
  onTransfer = () => {
    const { selectedElement, dispatch } = this.props;
    const element = { ...selectedElement };
    element.page = element.page + 1;
    dispatch(formActions.transfer(element));
  };
  navigateToTemplateEditor = () => {
    const { template, dispatch } = this.props;
    dispatch(cmsActions.setSourceLocation(window.location.pathname), sourceTypes.FORM);
    window.open(`/cms/template/${template.templateId}`);
  };
  togglePopover = () => {
    this.setState({ displayPopOver: false, popoverMessage: "" });
  };
  restoreForm = () => {
    const { dispatch } = this.props;
    dispatch(formActions.restore());
  };
  renderTabContent = (activeTab) => {
    const { selectedElement, selectedContainer, form, enviroment, template } = this.props;
    if (activeTab === "ElementSettings" || selectedElement || selectedContainer) {
      return (
        <TabPane tabId="ElementSettings" style={{ paddingBottom: "65px" }}>
          {selectedElement ? renderElementSettings(selectedElement.type, selectedElement, this.props.toggleConditionModal) : null}
          {selectedContainer && !selectedElement ? <React.Fragment>{renderElementSettings(selectedContainer.type, selectedContainer, this.props.toggleConditionModal)}</React.Fragment> : null}
        </TabPane>
      );
    } else if (activeTab === "Elements") {
      return (
        <TabPane tabId="Elements" style={{ paddingBottom: "unset" }}>
          {enviroment === sourceTypes.EMAIL ? <EmailElements /> : <ElementsTab isSurvey={enviroment === sourceTypes.FORM && this.props.form.survey === true} />}
        </TabPane>
      );
    } else if ((activeTab === "TemplateSettings" && template.inherit !== false) || (activeTab === "TemplateSettings" && template.eventId === this.props.cms.eventId)) {
      return (
        <TabPane tabId="TemplateSettings" style={{ paddingBottom: "100px" }}>
          <TemplateSettings />
        </TabPane>
      );
    } else if (activeTab === "EmailSettings") {
      return (
        <TabPane tabId="EmailSettings" style={{ paddingBottom: "100px" }}>
          <EmailSettings />
        </TabPane>
      );
    } else if (activeTab === "FormSettings") {
      return (
        <TabPane tabId="FormSettings" style={{ paddingBottom: "100px" }}>
          <FormSettings />
        </TabPane>
      );
    } else if (activeTab === "PageSettings") {
      return (
        <TabPane tabId="PageSettings" style={{ paddingBottom: "100px" }}>
          <PageSettings />
        </TabPane>
      );
    } else if (activeTab === "TemplateInternalSettings") {
      return (
        <TabPane tabId="TemplateInternalSettings" style={{ paddingBottom: "100px" }}>
          <TemplateInternalSettings />
        </TabPane>
      );
    }
  };
  setOverflow = (activeTab) => {
    switch (activeTab) {
      case "FormSettings":
        return "auto";
      case "ElementSettings":
        if (this.props.enviroment === sourceTypes.EMAIL && this.props.selectedElement) {
          return "auto";
        }
        if (this.props.selectedElement && this.props.selectedElement.type === elementConstants.CONTENT) {
          return "auto";
        }
        if (!this.props.selectedElement && this.props.selectedContainer) {
          return "auto";
        }
        return "hidden";
      case "Element":
        return "hidden";
      case "TemplateSettings":
        return "auto";
      default:
        return "auto";
    }
  };
  onNameEdit = (name) => {
    this.setState({ copyName: name });
  };
  render() {
    const { selectedElement, selectedContainer, form, page, enviroment, template, tempIsSavable, email } = this.props;

    let activeTab = this.state.activeTab;
    if (selectedElement || selectedContainer) {
      activeTab = "ElementSettings";
    }
    if (template === undefined) return null;
    return (
      <React.Fragment>
        <div ref={(r) => (this.asideEditorRef = r)}>
          <Nav
            className="editor-nav"
            tabs
            style={{
              padding: "0px",
            }}
          >
            <NavItem onClick={() => (form.isSavable || page.isSavable || tempIsSavable || email.isSavable ? this.save() : null)}>
              <NavLink
                className="nav-toolbar-item"
                style={form.isSavable || page.isSavable || tempIsSavable || email.isSavable ? { backgroundColor: "#4dbd74", color: "#fff" } : { opacity: 0.7 }}
                /*      onClick={() => this.save()} */
                id="saveOpen"
              >
                <SaveIcon style={form.isSavable || page.isSavable || tempIsSavable || email.isSavable ? { color: "#fff" } : { color: "#e4e3e3" }} />
                {/*<br />*/}
                {/*<p className="sidebar-tools-labels">*/}
                {/*  Save*/}
                {/*</p>*/}
              </NavLink>
           
            </NavItem>
            {enviroment === sourceTypes.FORM ? <RunFormOption /> : null}
            {enviroment === sourceTypes.PAGE ? (
              <NavItem>
                <NavLink style={{ textAlign: "center", opacity: "0.7" }} className="nav-toolbar-item" id="openPage" onClick={this.openPage}>
                  <LaunchIcon className="editor-toolbar-icon" />
                  {/*<br />*/}
                  {/*<p className="sidebar-tools-labels">*/}
                  {/*  Preview*/}
                  {/*</p>*/}
                </NavLink>
              </NavItem>
            ) : null}
            {enviroment === sourceTypes.EMAIL ? <SendTestEmail /> : null}
            {enviroment === sourceTypes.FORM && form.settings !== undefined ? (
              <NavItem>
                <Tooltip TransitionComponent={Zoom} placement="top" title={labelHelper.getLabel("FormSettings")}>
                  <NavLink
                    className="nav-toolbar-item"
                    id="formSettingsOpen"
                    style={{ textAlign: "center", opacity: "0.7" }}
                    onClick={() => {
                      this.toggle("FormSettings");
                    }}
                  >
                    <SettingsIcon className="editor-toolbar-icon" />
                    {/*<br />*/}
                    {/*<p className="sidebar-tools-labels">*/}
                    {/*  Settings*/}
                    {/*</p>*/}
                  </NavLink>
                </Tooltip>
              </NavItem>
            ) : null}
            {enviroment === sourceTypes.PAGE ? (
              <NavItem>
                <MLToolTip title={<SystemLabel name="PageSettings" />}>
                  <NavLink
                    className="nav-toolbar-item"
                    id="PageSettings"
                    style={{textAlign:"center",opacity:"0.7"}}
                    onClick={() => {
                      this.toggle("PageSettings");
                    }}
                  >
                    <i className="fa fa-cog editor-toolbar-icon" />
                    {/*<br />*/}
                    {/*<p className="sidebar-tools-labels">*/}
                    {/*  Devices*/}
                    {/*</p>*/}
                  </NavLink>
                </MLToolTip>
              </NavItem>
            ) : null}
            {enviroment === sourceTypes.TEMPLATE ? (
              <NavItem>
                <MLToolTip title={<SystemLabel name="TemplateSettings" />}>
                  <NavLink
                    className="nav-toolbar-item"
                    style={{ textAlign: "center", opacity: "0.7" }}
                    id="TemplateSettings"
                    onClick={() => {
                      this.toggle("TemplateInternalSettings");
                    }}
                  >
                    <i className="fa fa-cog editor-toolbar-icon" />
                  </NavLink>
                </MLToolTip>
              </NavItem>
            ) : null}
            {enviroment !== sourceTypes.TEMPLATE && enviroment !== sourceTypes.EMAIL ? <PreviewOption /> : null}
            {enviroment == sourceTypes.FORM ? (
              <NavItem>
                <Tooltip TransitionComponent={Zoom} placement="top" title={labelHelper.getLabel("Restore")}>
                  <NavLink
                    className="nav-toolbar-item"
                    id="clearOpen"
                    style={{ textAlign: "center", opacity: "0.7" }}
                    onClick={() => {
                      this.restoreForm();
                    }}
                  >
                    <RestorePageIcon className=" editor-toolbar-icon" />
                    {/*<br />*/}
                    {/*<p className="sidebar-tools-labels">*/}
                    {/*  Restore*/}
                    {/*</p>*/}
                  </NavLink>
                </Tooltip>
              </NavItem>
            ) : null}
          </Nav>
          {enviroment === sourceTypes.FORM ? (
            <Nav style={{ borderBottom: "1px solid gainsboro" }}>
              <FormPagination pages={form.pages} currentPage={form.currentPage} removePage={() => this.removePage(form.currentPage)} addPage={this.addPage} navigate={this.scrollPage} />
            </Nav>
          ) : null}
          <div style={{ position: "relative" }}>
            {!this.props.isOwner ? <InheritageWrapper status={this.props.inherit} /> : null}
            {activeTab !== "ElementSettings" ? (
              <EditorTabGroup
                activeTab={activeTab}
                toggle={this.toggle}
                email={enviroment === sourceTypes.EMAIL ? true : false}
                isOwner={template.eventId === this.props.cms.eventId}
                tempIsInherited={this.props.template.inherit}
              />
            ) : null}
            <div>
              <TabContent
                className="editor-tabcontent"
                style={{
                  height: enviroment === sourceTypes.EMAIL ? "100%" : undefined,
                  overflowY: this.setOverflow(activeTab),
                  height: enviroment === sourceTypes.PAGE ? "calc(100vh - 2.375rem )" : undefined,
                }}
                activeTab={activeTab}
              >
                {this.renderTabContent(activeTab)}
              </TabContent>
            </div>
          </div>
        </div>
        {this.state.confirmModal ? (
          <ConfirmModal
            open={this.state.confirmModal}
            header="AreYoySure"
            showNameInput={!this.props.isOwner || (this.props.inherit == true && this.props.cms.inheritageAffected) ? true : false}
            onNameEdit={(value, path) => {
              const affectedAreas = Array.from(this.state.affected);
              affectedAreas.map((a) => {
                if (a.area == path) {
                  a.name = value;
                }
              });
              this.setState({ affected: affectedAreas });
            }}
            extraProps={null}
            affected={this.state.affected}
            text={this.state.inheritedElements ? <SystemLabel name={this.state.copyArea} /> : <SystemLabel name="ACopyWillBeCreatedDueToInheritence" />}
            onAction={() => this.save(true)}
            onCancel={() => this.setState({ confirmModal: false })}
          />
        ) : null}
        <AlertDialog />
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { enviroment } = state.cms;
  let selectedContainer = null;
  let selectedElement = null;
  let inherit = null;
  let isOwner = false;

  if (enviroment === sourceTypes.FORM) {
    inherit = state.form ? state.form.inherit : null;
    selectedElement = state.form.selectedElement;
    selectedContainer = state.form.selectedContainer;
    isOwner = state.form ? state.cms.eventId == state.form.eventId && state.form.inheritParentId == null : false;
  }
  if (enviroment === sourceTypes.PAGE) {
    inherit = state.page ? state.page.inherit : null;
    selectedElement = state.page.selectedElement;
    selectedContainer = state.page.selectedContainer;
    isOwner = state.page ? state.cms.eventId == state.page.eventId : false;
  }
  if (enviroment === sourceTypes.TEMPLATE) {
    inherit = state.template.template ? state.template.template.inherit : null;
    selectedElement = state.template.selectedElement;
    selectedContainer = state.template.selectedContainer;
    isOwner = state.template.template ? state.cms.eventId == state.template.template.eventId : false;
  }

  if (enviroment === sourceTypes.EMAIL) {
    selectedElement = state.email.selectedElement;
    selectedContainer = null;
  }
  return {
    selectedElement,
    selectedContainer,
    page: state.page,
    form: state.form,
    email: state.email,
    enviroment: state.cms.enviroment,
    template: state.template.template,
    tempIsSavable: state.template.isSavable,
    cms: state.cms,
    inherit,
    isOwner,
  };
}
export default connect(mapStateToProps)(EditorSidebar);
